var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,_vm._b({tag:"component",attrs:{"location":_vm.location}},'component',_vm.payload,false)):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }